module.exports = __webpack_public_path__ + "static/media/logo.e99f45a4.png";